import { adminNotificationTemplateQueryKeys as e } from "./adminNotificationTemplateQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminNotificationsApi as r } from "@maat/api-notifications";
//#region src/notifications/admin/useUpdateAdminNotificationTemplateMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.updateTemplate(e.id, e.data),
		onSuccess: (t, n) => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.detail(n.id) });
		}
	});
};
//#endregion
export { i as useUpdateAdminNotificationTemplateMutation };
